document.addEventListener('mousemove', function (event) {
  const container = event.target.closest('.product-media-container');

  if (!container) return;

  const image = container.querySelector('.product-media__image');

  if (!image) return;

  const rect = container.getBoundingClientRect();
  const x = ((event.clientX - rect.left) / rect.width) * 100;
  const y = ((event.clientY - rect.top) / rect.height) * 100;

  image.style.setProperty('--zoom-x', `${x}%`);
  image.style.setProperty('--zoom-y', `${y}%`);
});

document.addEventListener('mouseleave', function (event) {
  const container = event.target.closest?.('.product-media-container');

  if (!container) return;

  const image = container.querySelector('.product-media__image');

  if (!image) return;

  image.style.removeProperty('--zoom-x');
  image.style.removeProperty('--zoom-y');
}, true);
document.addEventListener('keydown', function (event) {
  if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const button =
    event.key === 'ArrowLeft'
      ? gallery.querySelector('slideshow-arrows .slideshow-control:first-of-type')
      : gallery.querySelector('slideshow-arrows .slideshow-control:last-of-type');

  if (!button) return;

  event.preventDefault();
  button.click();
});